import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/database'
  // Your web app's Firebase configuration
  var firebaseConfig = {
    apiKey: "AIzaSyD0iJKMedWodl3iFpOiDz_VV0jeH2c0fN0",
    authDomain: "hiropay-6c8a4.firebaseapp.com",
    databaseURL: "https://hiropay-6c8a4.firebaseio.com",
    projectId: "hiropay-6c8a4",
    storageBucket: "hiropay-6c8a4.appspot.com",
    messagingSenderId: "804190494620",
    appId: "1:804190494620:web:f9fd608338862089847259"
  };
  
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);

 export default !firebase.apps.length ? firebase.initializeApp(firebaseConfig) : firebase;